import React, { useState, useEffect } from "react";
// import { Provider } from '@shopify/app-bridge-react';
import { RouteComponentProps } from "react-router";
import { Redirect } from "react-router-dom";
import { parseQueryString } from "lib/query-string";
import { ErrorScreen } from "screens";
import {
  API_GATEWAY,
  AUTH_TOKEN_KEY,
  SHOPIFY_APP_PERMALINK,
  SHOPIFY_API_KEY
} from "aws-exports";
import validShopifyDomain from "valid-shopify-domain";
import { FormGroup, FormControl, Input, Button, Spinner } from "components";
import classNames from "lib/classNames";

import Logo from "svgs/monster_logo.png";
import { ReactComponent as Dots } from "svgs/dots.svg";
const LoginScreen = (props) => {
  const { shop } = parseQueryString(props.location.search);
  const [state, setState] = useState({
    disableInstall: false,
    errorMessage: undefined,
    installMessage: "Install",
    shop: shop || "",
    redirectToHome: false
  });
  const shopErrorMessage = (shop) => {
    try {
      validShopifyDomain(shop);
      return undefined;
    } catch (error) {
      console.log(error);
      return "invalid shop URL";
    }
  };
  const handleChange = (value, key) => {
    setState({
      ...state,
      [key]: value
        .replace(/https:\/\//, "")
        .replace(/http:\/\//, "")
        .replace(/wwww\./, "")
        .replace(/\//, "")
    });
  };
  const handleSubmit = (evt) => {
    evt.preventDefault();
    const errorMessage = shopErrorMessage(state.shop);
    setState({ ...state, errorMessage });
    if (errorMessage === undefined) {
      doLogin(state.shop);
    }
  };
  const doLogin = async (shop) => {
    setState({
      ...state,
      disableInstall: true,
      installMessage: "Please wait..."
    });
    // affj things
    const invitation = localStorage.getItem("invitation_id");
    const { id = null, expiry = 0 } = JSON.parse(invitation || "{}");
    let referral = id && expiry > new Date().getTime() ? id : undefined;

    // new affiliation system things
    let ls_aff_code = localStorage.getItem("aff_code");
    let { code: aff_code = null, expiry: aff_code_expiry = 0 } = JSON.parse(
      ls_aff_code || "{}"
    );
    aff_code =
      aff_code && aff_code_expiry > new Date().getTime() ? aff_code : undefined;

    // new system overrides affjungle
    if (aff_code) referral = undefined;
    const callbackUrl = `${window.location.protocol}//${
      window.location.hostname
    }${
      !!window.location.port ? ":" + window.location.port : ""
    }/auth/shopify/callback`;
    const url = `${API_GATEWAY}/auth/shopify?callback-url=${callbackUrl}&shop=${shop}${
      referral ? "&invitation=" + referral : ""
    }${aff_code ? "&aff_code=" + aff_code : ""}`;
    try {
      const result = await fetch(url, { cache: "no-cache", method: "GET" });
      if (result.ok) {
        const json = await result.json();
        localStorage.setItem(`${AUTH_TOKEN_KEY}_${shop}`, json.token);
        if (window.top === window.self) window.location.href = json.authUrl;
        else return setState({ ...state, redirectToHome: true });
      } else {
        console.error(result.statusText);
      }
    } catch (err) {
      console.error(err);
    }
    setState({
      ...state,
      disableInstall: false,
      errorMessage: "API Call Failed.",
      installMessage: "Install"
    });
  };

  useEffect(() => {
    if (shop !== undefined) {
      const errorMessage = shopErrorMessage(shop);
      if (errorMessage === undefined) doLogin(shop);
      else setState({ ...state, errorMessage });
    }
  }, []);
  if (state.redirectToHome)
    return <Redirect to={{ pathname: "/", search: props.location.search }} />;
  return window.top !== window.self && !!shop ? (
    <Spinner text="Authentication" />
  ) : (
    <div role="main" className={classNames("flex-center flex-col h-full")}>
      <div
        className={classNames(
          "bg-blue-200 flex-center flex-col p-10 rounded-lg"
        )}
        style={{ width: "500px", maxWidth: "95%", position: "relative" }}
      >
        <div
          className={classNames("rounded-lg bg-white p-2")}
          style={{ width: "110px", top: "-69px", position: "absolute" }}
        >
          <img src={Logo} className={classNames("rounded-lg ")} />
        </div>
        <p className={classNames("text-lg font-medium mt-4 mb-5")}>
          Please enter your store URL
        </p>

        <Input
          autoFocus={true}
          error={state.errorMessage}
          onChange={(value) => handleChange(value, "shop")}
          placeholder="example.myshopify.com"
          value={state.shop}
          inputBackground="bg-white"
        />
        <div className={classNames("flex-center flex-col my-4 w-full")}>
          <Button
            type="primary"
            // loading={state.disableInstall}
            // disabled={state.disableInstall}
            onClick={(e) => handleSubmit(e)}
            text={state.installMessage}
            className={classNames(
              "w-full rounded rounded-sm text-lg font-medium"
            )}
          />
        </div>
        <div
          style={{
            width: " 142px",
            height: "112px",
            position: "absolute",
            bottom: "-59px",
            left: "-74px"
          }}
        >
          <Dots />
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;

// domain.match(/^(http|https|www\.):\/\//g)
// null
// domain.match(/^(http|https|www):\/\//g)
// null
// domain.match(/^(http|https|www)/g)
